import React from 'react';

const Svg = ({ size = 20, children, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...rest}>
    {children}
  </svg>
);

export const IconPlay = (p) => (
  <Svg {...p}>
    <path d="M8.5 5.14a1 1 0 0 1 1.51-.86l11 6.86a1 1 0 0 1 0 1.72l-11 6.86a1 1 0 0 1-1.51-.86V5.14z" transform="translate(-2 0)" />
  </Svg>
);

export const IconPause = (p) => (
  <Svg {...p}>
    <rect x="6" y="4.5" width="4" height="15" rx="1.2" />
    <rect x="14" y="4.5" width="4" height="15" rx="1.2" />
  </Svg>
);

export const IconPrev = (p) => (
  <Svg {...p}>
    <rect x="4" y="5" width="2.4" height="14" rx="1" />
    <path d="M20 6.2a1 1 0 0 0-1.53-.85L9.6 11.15a1 1 0 0 0 0 1.7l8.87 5.8A1 1 0 0 0 20 17.8V6.2z" />
  </Svg>
);

export const IconNext = (p) => (
  <Svg {...p}>
    <rect x="17.6" y="5" width="2.4" height="14" rx="1" />
    <path d="M4 6.2a1 1 0 0 1 1.53-.85l8.87 5.8a1 1 0 0 1 0 1.7l-8.87 5.8A1 1 0 0 1 4 17.8V6.2z" />
  </Svg>
);

export const IconBack10 = (p) => (
  <Svg {...p}>
    <path
      d="M12 4V1.8L7.6 4.9 12 8V6c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7H3c0 5 4 9 9 9s9-4 9-9-4-9-9-9z"
      fillRule="evenodd"
    />
    <text x="12" y="16.3" textAnchor="middle" fontSize="7.4" fontWeight="700" fontFamily="inherit" fill="currentColor" stroke="none">
      10
    </text>
  </Svg>
);

export const IconFwd10 = (p) => (
  <Svg {...p}>
    <path
      d="M12 4V1.8l4.4 3.1L12 8V6c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7h2c0 5-4 9-9 9s-9-4-9-9 4-9 9-9z"
      fillRule="evenodd"
    />
    <text x="12" y="16.3" textAnchor="middle" fontSize="7.4" fontWeight="700" fontFamily="inherit" fill="currentColor" stroke="none">
      10
    </text>
  </Svg>
);

export const IconSearch = (p) => (
  <Svg {...p}>
    <path d="M10.5 3a7.5 7.5 0 1 0 4.55 13.46l4.24 4.25a1.1 1.1 0 0 0 1.56-1.56l-4.25-4.24A7.5 7.5 0 0 0 10.5 3zm0 2.2a5.3 5.3 0 1 1 0 10.6 5.3 5.3 0 0 1 0-10.6z" />
  </Svg>
);

export const IconQueue = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="2.2" rx="1.1" />
    <rect x="3" y="10.9" width="18" height="2.2" rx="1.1" />
    <rect x="3" y="16.8" width="11" height="2.2" rx="1.1" />
    <path d="M17.5 15.2a1 1 0 0 1 1.5-.87l3 1.8a1 1 0 0 1 0 1.74l-3 1.8a1 1 0 0 1-1.5-.87v-3.6z" />
  </Svg>
);

export const IconClose = (p) => (
  <Svg {...p}>
    <path d="M6.2 6.2a1.1 1.1 0 0 1 1.56 0L12 10.44l4.24-4.24a1.1 1.1 0 1 1 1.56 1.56L13.56 12l4.24 4.24a1.1 1.1 0 1 1-1.56 1.56L12 13.56 7.76 17.8a1.1 1.1 0 0 1-1.56-1.56L10.44 12 6.2 7.76a1.1 1.1 0 0 1 0-1.56z" />
  </Svg>
);

export const IconVolume = ({ level = 1, ...p }) => (
  <Svg {...p}>
    <path d="M4 9.5A1.5 1.5 0 0 1 5.5 8h2.6l4.1-3.4c.65-.54 1.63-.08 1.63.76v13.28c0 .84-.98 1.3-1.63.76L8.1 16H5.5A1.5 1.5 0 0 1 4 14.5v-5z" />
    {level > 0 && <path d="M16.2 9.1a1 1 0 0 1 1.4.2 4.5 4.5 0 0 1 0 5.4 1 1 0 1 1-1.6-1.2 2.5 2.5 0 0 0 0-3 1 1 0 0 1 .2-1.4z" />}
    {level > 0.55 && <path d="M18.6 6.3a1 1 0 0 1 1.4.17 8.5 8.5 0 0 1 0 11.06 1 1 0 0 1-1.53-1.29 6.5 6.5 0 0 0 0-8.48 1 1 0 0 1 .13-1.46z" />}
  </Svg>
);

export const IconMic = (p) => (
  <Svg {...p}>
    <rect x="9" y="2.5" width="6" height="11" rx="3" />
    <path d="M6 11a1 1 0 0 1 2 0 4 4 0 0 0 8 0 1 1 0 0 1 2 0 6 6 0 0 1-5 5.92V19h2a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2h2v-2.08A6 6 0 0 1 6 11z" />
  </Svg>
);

export const IconNote = (p) => (
  <Svg {...p}>
    <path d="M9 3.6a1 1 0 0 1 .76-.97l9-2.25A1 1 0 0 1 20 1.35V14.5a3.5 3.5 0 1 1-2-3.16V5.03l-7 1.75v10.72a3.5 3.5 0 1 1-2-3.16V3.6z" transform="translate(0 2)" />
  </Svg>
);

export const IconChevronDown = (p) => (
  <Svg {...p}>
    <path d="M5.3 8.8a1.1 1.1 0 0 1 1.56 0L12 13.94l5.14-5.14a1.1 1.1 0 1 1 1.56 1.56l-5.92 5.92a1.1 1.1 0 0 1-1.56 0L5.3 10.36a1.1 1.1 0 0 1 0-1.56z" />
  </Svg>
);

export const IconStar = (p) => (
  <Svg {...p}>
    <path d="M12 2.6l2.6 5.9 6.4.62-4.8 4.3 1.37 6.3L12 16.4l-5.57 3.3 1.37-6.3L3 9.12l6.4-.62L12 2.6z" />
  </Svg>
);

export const IconArrowDown = (p) => (
  <Svg {...p}>
    <path d="M12 3a1 1 0 0 1 1 1v12.1l4.3-4.3a1 1 0 1 1 1.4 1.42l-6 6a1 1 0 0 1-1.4 0l-6-6A1 1 0 0 1 6.7 11.8l4.3 4.3V4a1 1 0 0 1 1-1z" />
  </Svg>
);

export const IconSun = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="4.4" />
    <path d="M12 1.6a1 1 0 0 1 1 1v1.9a1 1 0 0 1-2 0V2.6a1 1 0 0 1 1-1zm0 16.9a1 1 0 0 1 1 1v1.9a1 1 0 0 1-2 0v-1.9a1 1 0 0 1 1-1zM1.6 12a1 1 0 0 1 1-1h1.9a1 1 0 0 1 0 2H2.6a1 1 0 0 1-1-1zm16.9 0a1 1 0 0 1 1-1h1.9a1 1 0 0 1 0 2h-1.9a1 1 0 0 1-1-1zM4.6 4.6a1 1 0 0 1 1.4 0l1.35 1.34A1 1 0 0 1 5.94 7.4L4.6 6.04a1 1 0 0 1 0-1.42zm12.05 12.06a1 1 0 0 1 1.42 0l1.34 1.34a1 1 0 0 1-1.42 1.42l-1.34-1.35a1 1 0 0 1 0-1.41zm2.76-12.05a1 1 0 0 1 0 1.41L18.06 7.4a1 1 0 0 1-1.41-1.42l1.34-1.34a1 1 0 0 1 1.42 0zM7.35 16.65a1 1 0 0 1 0 1.41L6 19.4a1 1 0 0 1-1.41-1.42l1.34-1.34a1 1 0 0 1 1.41 0z" />
  </Svg>
);

export const IconMoon = (p) => (
  <Svg {...p}>
    <path d="M20.6 14.5a8.8 8.8 0 0 1-11-11.1 1 1 0 0 0-1.3-1.2 10.3 10.3 0 1 0 13.5 13.6 1 1 0 0 0-1.2-1.3z" />
  </Svg>
);

// ---- Set Search + Vibe icons (contract D.8) ------------------------------

// outlined die (a rounded square ring, same weight as the search ring) with five pips
export const IconDice = (p) => (
  <Svg {...p}>
    <path
      fillRule="evenodd"
      d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm.2 2A2.2 2.2 0 0 0 5 7.2v9.6A2.2 2.2 0 0 0 7.2 19h9.6a2.2 2.2 0 0 0 2.2-2.2V7.2A2.2 2.2 0 0 0 16.8 5H7.2zM8.6 7.3a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6zm6.8 0a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6zM12 10.7a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6zm-3.4 3.4a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6zm6.8 0a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6z"
    />
  </Svg>
);

// concentric arcs around a dot
export const IconRadio = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="2.2" />
    <path d="M7.76 16.24A5.98 5.98 0 0 1 6 12c0-1.66.67-3.16 1.76-4.24l1.42 1.42A3.99 3.99 0 0 0 8 12c0 1.1.45 2.1 1.17 2.83l-1.41 1.41zm8.48 0A5.98 5.98 0 0 0 18 12c0-1.66-.67-3.16-1.76-4.24l-1.42 1.42A3.99 3.99 0 0 1 16 12c0 1.1-.45 2.1-1.17 2.83l1.41 1.41zM20 12c0 2.21-.9 4.21-2.35 5.65l1.42 1.42A9.97 9.97 0 0 0 22 12c0-2.76-1.12-5.26-2.93-7.07l-1.42 1.42A7.97 7.97 0 0 1 20 12zM6.35 6.35L4.93 4.93A9.97 9.97 0 0 0 2 12c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.97 7.97 0 0 1 4 12c0-2.21.9-4.21 2.35-5.65z" />
  </Svg>
);

export const IconPlusCircle = (p) => (
  <Svg {...p}>
    <path
      fillRule="evenodd"
      d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 4.9a1.1 1.1 0 0 0-1.1 1.1v2.9H8a1.1 1.1 0 0 0 0 2.2h2.9V16a1.1 1.1 0 0 0 2.2 0v-2.9H16a1.1 1.1 0 0 0 0-2.2h-2.9V8A1.1 1.1 0 0 0 12 6.9z"
    />
  </Svg>
);

// "into" connector: IconArrowDown turned to point right
export const IconArrowRight = (p) => (
  <Svg {...p}>
    <path
      d="M12 3a1 1 0 0 1 1 1v12.1l4.3-4.3a1 1 0 1 1 1.4 1.42l-6 6a1 1 0 0 1-1.4 0l-6-6A1 1 0 0 1 6.7 11.8l4.3 4.3V4a1 1 0 0 1 1-1z"
      transform="rotate(-90 12 12)"
    />
  </Svg>
);

export const IconSparkle = (p) => (
  <Svg {...p}>
    <path d="M10 4.5c.55 4.3 2.7 6.45 7 7-4.3.55-6.45 2.7-7 7-.55-4.3-2.7-6.45-7-7 4.3-.55 6.45-2.7 7-7z" />
    <path d="M18.5 2c.25 1.9 1.1 2.75 3 3-1.9.25-2.75 1.1-3 3-.25-1.9-1.1-2.75-3-3 1.9-.25 2.75-1.1 3-3z" />
    <path d="M18 15.5c.2 1.5.9 2.2 2.4 2.4-1.5.2-2.2.9-2.4 2.4-.2-1.5-.9-2.2-2.4-2.4 1.5-.2 2.2-.9 2.4-2.4z" />
  </Svg>
);

export const IconLink = (p) => (
  <Svg {...p}>
    <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7a5 5 0 0 0 0 10h4v-1.9H7A3.1 3.1 0 0 1 3.9 12zM8 13h8v-2H8v2zm9-6h-4v1.9h4a3.1 3.1 0 0 1 0 6.2h-4V17h4a5 5 0 0 0 0-10z" />
  </Svg>
);

export const IconBookmark = (p) => (
  <Svg {...p}>
    <path d="M7 3h10a2 2 0 0 1 2 2v15.3a.7.7 0 0 1-1.1.58L12 17.2l-5.9 3.68A.7.7 0 0 1 5 20.3V5a2 2 0 0 1 2-2z" />
  </Svg>
);

export const IconThumbUp = (p) => (
  <Svg {...p}>
    <path d="M2 21h3a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1zm21-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 8.59 6.59C8.22 6.95 8 7.45 8 8v11c0 1.1.9 2 2 2h8c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z" />
  </Svg>
);

export const IconThumbDown = (p) => (
  <Svg {...p}>
    <path d="M22 3h-3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l5.58-5.59c.37-.36.59-.86.59-1.41V5c0-1.1-.9-2-2-2H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2z" />
  </Svg>
);

export const IconTrash = (p) => (
  <Svg {...p}>
    <path d="M6 7.5h12l-.85 11.7A2 2 0 0 1 15.16 21H8.84a2 2 0 0 1-1.99-1.8L6 7.5zM9.5 3h5a1 1 0 0 1 1 1v.5H19a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h3.5V4a1 1 0 0 1 1-1z" />
  </Svg>
);

export const IconRefresh = (p) => (
  <Svg {...p}>
    <path d="M17.65 6.35A7.96 7.96 0 0 0 12 4a8 8 0 1 0 7.73 10h-2.08A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
  </Svg>
);

// "Open full show": a list with an arrow pointing into it
export const IconOpen = (p) => (
  <Svg {...p}>
    <rect x="13" y="5.4" width="8.5" height="2.2" rx="1.1" />
    <rect x="15" y="10.9" width="6.5" height="2.2" rx="1.1" />
    <rect x="13" y="16.4" width="8.5" height="2.2" rx="1.1" />
    <path d="M2.5 11H7V7.9c0-.52.62-.8 1.01-.45l4.3 3.8c.33.3.33.8 0 1.1l-4.3 3.8A.6.6 0 0 1 7 15.7V13H2.5a1 1 0 0 1 0-2z" />
  </Svg>
);

export const IconChevronRight = (p) => (
  <Svg {...p}>
    <path
      d="M5.3 8.8a1.1 1.1 0 0 1 1.56 0L12 13.94l5.14-5.14a1.1 1.1 0 1 1 1.56 1.56l-5.92 5.92a1.1 1.1 0 0 1-1.56 0L5.3 10.36a1.1 1.1 0 0 1 0-1.56z"
      transform="rotate(-90 12 12)"
    />
  </Svg>
);

export const IconFilter = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="2.2" rx="1.1" />
    <rect x="6" y="10.9" width="12" height="2.2" rx="1.1" />
    <rect x="9.5" y="16.8" width="5" height="2.2" rx="1.1" />
  </Svg>
);

export const IconInfo = (p) => (
  <Svg {...p}>
    <path
      fillRule="evenodd"
      d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 8.4a1.1 1.1 0 0 0-1.1 1.1v5a1.1 1.1 0 0 0 2.2 0v-5a1.1 1.1 0 0 0-1.1-1.1zm0-4a1.35 1.35 0 1 0 0 2.7 1.35 1.35 0 0 0 0-2.7z"
    />
  </Svg>
);

// "Sandwich": stacked layers
export const IconLayers = (p) => (
  <Svg {...p}>
    <path d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z" />
  </Svg>
);

// Band list toggle (narrow layouts): bullets and lines
export const IconList = (p) => (
  <Svg {...p}>
    <circle cx="4.6" cy="6.1" r="1.6" />
    <circle cx="4.6" cy="12" r="1.6" />
    <circle cx="4.6" cy="17.9" r="1.6" />
    <rect x="8.5" y="5" width="12.5" height="2.2" rx="1.1" />
    <rect x="8.5" y="10.9" width="12.5" height="2.2" rx="1.1" />
    <rect x="8.5" y="16.8" width="12.5" height="2.2" rx="1.1" />
  </Svg>
);

export const IconChevronLeft = (p) => (
  <Svg {...p}>
    <path
      d="M5.3 8.8a1.1 1.1 0 0 1 1.56 0L12 13.94l5.14-5.14a1.1 1.1 0 1 1 1.56 1.56l-5.92 5.92a1.1 1.1 0 0 1-1.56 0L5.3 10.36a1.1 1.1 0 0 1 0-1.56z"
      transform="rotate(90 12 12)"
    />
  </Svg>
);

// Overflow menu: three dots
export const IconMore = (p) => (
  <Svg {...p}>
    <circle cx="5.2" cy="12" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="18.8" cy="12" r="2" />
  </Svg>
);
